// action
import {
    GET_TRIBE_ARTICLE_LIST,
    GET_TRIBE_ARTICLE_LIST_FAIL,
    GET_TRIBE_ARTICLE_LIST_SUCCESS,
    GET_TRIBE_ARTICLE_LIST_RESET
} from '../action/getTribeArticleListAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_TRIBE_ARTICLE_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_TRIBE_ARTICLE_LIST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_TRIBE_ARTICLE_LIST_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_TRIBE_ARTICLE_LIST_RESET:
            return initialState
        default:
            return state
    }
}